var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("ModalPopupInfo", { ref: "modalPopupInfo" }),
      _c("div", { staticClass: "flex-center-space-between" }, [
        _c(
          "div",
          { staticClass: "mr-1", staticStyle: { width: "50%" } },
          [_c("WidgetLivraisons")],
          1
        ),
        _c(
          "div",
          { staticClass: "ml-1", staticStyle: { width: "50%" } },
          [_c("WidgetInformations")],
          1
        )
      ]),
      _c("div", { staticClass: "flex-center-space-between" }, [
        _c(
          "div",
          {
            staticClass: "mr-1",
            style: "width:" + (_vm.afficheActualite ? "50%" : "100%")
          },
          [_c("WidgetProductions")],
          1
        ),
        _vm.afficheActualite
          ? _c(
              "div",
              { staticClass: "ml-1", staticStyle: { width: "50%" } },
              [_c("WidgetActualites")],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }